import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Plus } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
// --- Styled Components --- 
// 인라인 형태에 맞게 간결하게 스타일링
const FormContainer = styled.form`
  display: flex;
  align-items: center;
  gap: 8px; // 요소 간 간격
  margin-top: 8px; // 강의 목록과의 간격
`;
const Input = styled.input`
  flex-grow: 1; // 남은 공간 차지
  padding: 6px 10px; // 패딩 줄임
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 0.9rem;
  box-sizing: border-box;
`;
// 버튼 크기 조절 (Button 컴포넌트의 size prop 활용 또는 새 스타일)
// 여기서는 기존 Button 사용하고 필요 시 size prop 사용
const LectureCreateInlineForm = ({ sectionId, onSubmit, isLoading, placeholderText, ariaLabel })=>{
    const [title, setTitle] = useState('');
    const handleChange = (e)=>{
        setTitle(e.target.value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!title.trim()) {
            // 간단한 인라인 폼이므로 alert 대신 포커스 이동 등 고려 가능
            // alert(m.alert_lecture_title_required()); 
            return;
        }
        onSubmit({
            title
        });
        setTitle(''); // 제출 후 입력 필드 초기화
    };
    return /*#__PURE__*/ _jsxs(FormContainer, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ _jsx(Input, {
                type: "text",
                name: "title",
                value: title,
                onChange: handleChange,
                placeholder: placeholderText,
                "aria-label": ariaLabel || `${placeholderText} (${sectionId})`,
                disabled: isLoading
            }),
            /*#__PURE__*/ _jsxs(Button, {
                type: "submit",
                variant: "secondary" // 또는 다른 적절한 variant
                ,
                size: "sm" // 작은 버튼 크기
                ,
                disabled: isLoading || !title.trim(),
                children: [
                    /*#__PURE__*/ _jsx(Plus, {
                        className: "h-4 w-4"
                    }),
                    " "
                ]
            })
        ]
    });
};
